import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiV2Service } from './api-v2.service'; 

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    constructor(private apiService:ApiV2Service) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        
        // Do not attach stale tokens to login/session-open calls.
        // Attaching an old Authtoken to /auth1/login can make V1 reject login for some users.
        if (
          request.url.includes('/auth/') ||
          request.url.includes('/auth1/login') ||
          request.url.includes('/auth1/startsession') ||
          (request.url.includes('/users/me') && request.method=='POST')
        ) {
            return next.handle(request);
          }
        
        // Per-account V1 logout already set Authtoken (primary + secondary).
        if (!request.url.includes('-v2-') && request.headers.has('Authtoken')) {
          return next.handle(request);
        }

        //currentUser?.token ?? 
        let currentUser = this.apiService.currentUserValue; 
        let cu_token = currentUser?.session?.access_token;

        //if request_url_ contains V1 use session_v1.token
        if(!request.url.includes('-v2-')) {
            cu_token = currentUser?.v1_data?.token;
        }

        if ((cu_token) && !( request.url.includes('/auth/refresh')|| request.url.includes('/custom-login'))) {
            
            let auth:any={
                Authorization: `Bearer ${cu_token}`
            };

            // if(request.url.includes('-v1-')) { 
            //     auth={
            //         Authtoken: `Bearer ${cu_token}`
            //     };
            // } 

             if(request.url.includes('-v2-')) { 
                auth={
                   Authorization: `Bearer ${cu_token}`
                };
            } else{
                 auth={
                    Authtoken: `Bearer ${cu_token}`
                };
            }
            
                request = request.clone({
                    setHeaders: auth
                });
         

         }

        return next.handle(request);
    }
}